import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';

import AdminKilometerService from '../../api/services/AdminKilometerService';

const KilometerList = () => {
    const [Error, setError] = useState('');
    const [isLoading, setisloading] = useState(true);
    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
    const [KilometerList, setKilometerList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = KilometerList.slice(firstIndex, lastIndex);
    const npage = Math.ceil(KilometerList.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }

    const kilometer = useRef();

    const getKilometerList = async () => {

        try {

            let responseData = await AdminKilometerService.index().json()
            setKilometerList(responseData.data)
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getKilometerList();

        }
        else {
            navigate('/');
        }

    }, [])
    const handleDelete = async (e) => {

        try {

            swal({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this data!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    let responseData = await AdminKilometerService.destroy(e).json()
                    if (responseData.status === true) {
                        swal("Kilometer Delete Succesfully").then((willDelete) => {
                            if (willDelete) {
                                getKilometerList();
                            }
                        })

                    }


                }
            }).catch(() => {
                swal("Your Camper Kilometer is safe!");
            });


        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    const handleCallback = () => {
        // Update the name in the component's state
        getKilometerList()

    }
    return (
        <>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">kilometer List</h4>
                                        <div>

                                            <Link to={`/admin/add_kilometer/`} className="btn btn-primary btn-sm ms-1" data-bs-toggle="offcanvas"
                                            // onClick={() => kilometer.current.showEmployeModal()}
                                            >+ Add kilometer</Link> {" "}

                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th >
                                                        <strong>No.</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Title</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Price</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Description</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Logo</strong>
                                                    </th>
                                                    <th style={{ textAlign: 'left' }}><strong>Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.map((element, index) => {

                                                        return (
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td>
                                                                    {index + 1}
                                                                </td>
                                                                <td>
                                                                    {element.title}

                                                                </td>

                                                                <td>{element.price}</td>
                                                                <td>{element.description}</td>
                                                                <td><img className="img-drop-area" height={element.icon ? 50 : 0} width={element.icon ? 50 : 0} src={imageUrl + "Kilometer/" + element.icon} alt='icon' /></td>
                                                                <td>
                                                                    <div className="d-flex">
                                                                        <Link

                                                                            to={`/admin/kilometerupdate/${element.id}`}
                                                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                                                        >
                                                                            <i className="fas fa-pencil-alt"></i>
                                                                        </Link>
                                                                        <Link
                                                                            onClick={() =>
                                                                                handleDelete(element.id)
                                                                            }

                                                                            className="btn btn-danger shadow btn-xs sharp"
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {KilometerList.length < lastIndex ? KilometerList.length : lastIndex}
                                                {" "}of {KilometerList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}


        </>
    );
};

export default KilometerList;
